import firebase from 'firebase/app';
import 'firebase/firestore';

const app = firebase.initializeApp({
  apiKey: 'AIzaSyDo34UVV1sUeX1dRTdJ2ZhdQfnfZ8lz24o',
  authDomain: 'bernardcapo-b6262.firebaseapp.com',
  databaseURL: 'https://bernardcapo-b6262.firebaseio.com',
  projectId: 'bernardcapo-b6262',
  storageBucket: 'bernardcapo-b6262.appspot.com',
  messagingSenderId: '1090630877998',
  appId: '1:1090630877998:web:6702184ff501e9163a30bf',
});

// export const db = app.database();
// export const newsRef = db.ref('news');

export const db = app.firestore();
export const newsCollection = db.collection('news');
